//
// toast.js
// Theme module
//

(function (waTheme) {

    var Toast = (function () {

        Toast = function (options) {
            var that = this;

            // DOM
            that.$wrapper = $(".toast-container");

            // VARS
            that.html = options["html"];

            // DYNAMIC VARS

            // INIT
            that.initToast();
        };

        Toast.prototype.initToast = function () {
            var that = this,
                html = `<div class="toast align-items-center bg-body-tertiary m-3 border-0 top-0 end-0" role="alert" aria-live="assertive" aria-atomic="true">
                    <button type="button" class="position-absolute btn-close text-success" data-bs-dismiss="toast" style="top: 7px; right: 7px;"></button>
                    <div class="p-4">
                        ${that.html}
                    </div>
                </div>`;

            if (that.html) {
                that.$wrapper.prepend(html)
                const toast = new bootstrap.Toast(that.$wrapper.find(".toast:not(.show):not(.hide)"), { animation: true });
                toast.show();
            }
        }

        return Toast;

    })();

    waTheme.init.site.Toast = Toast;

})(window.waTheme);